import { useEffect, useState } from "react";

import { cn } from "@/libs/utils";

import { showToast } from "@/utils/toastUtils";

import { ValueType } from "@/types/bid";

import { DefaultDashboardProjectTargetAchievementList } from "@/consts/Dashboard";

import { SetTargetArchievement } from "@/services/Dashboard";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import CommonImg from "@/components/Common/Img";
import CommonButton from "@/components/Common/Button";
import DashboardTargetAmountItem from "@/components/DashboardTargetAmountItem";

import CogWheelIcon from "@/assets/images/cogwheel-icon.png";

type Props = {
  dataList: ValueType[];
  onReload: () => void;
};
export default function DialogDashboardTargetAmount({
  dataList,
  onReload,
}: Props) {
  const [open, setOpen] = useState<boolean>(false);

  const [oldDataList, setOldDataList] = useState<ValueType[]>([]);
  const [newDataList, setNewDataList] = useState<ValueType[]>([]);

  const getInitialDataList = (items: ValueType[]) =>
    items[0].label === "-"
      ? DefaultDashboardProjectTargetAchievementList
      : items;

  const handleSaveTargetAchievement = async () => {
    try {
      const params = `[${newDataList.map((data) => `DashboardTargetAchievementItem(year=${data.label}, target_achievement=${data.value})`)}]`;
      const result = await SetTargetArchievement(params);
      if (result.data.success) {
        onReload();
        setOpen(false);
        showToast({
          message: "목표 금액 설정이 완료되었습니다.",
        });
      }
    } catch (e) {
      // Handle error
    } finally {
    }
  };

  const handleChangeTargetAchievement = (newItem: ValueType) => {
    setNewDataList((prev) =>
      prev.map((item) => (item.label !== newItem.label ? item : newItem))
    );
  };

  useEffect(() => {
    const initial = getInitialDataList(dataList);
    setNewDataList(initial);
    setOldDataList(initial);
  }, [dataList]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger>
        <CommonImg
          src={CogWheelIcon}
          alt={"Cog Wheel"}
          className={"size-[28px]"}
        />
      </DialogTrigger>
      <DialogContent onOpenAutoFocus={(e) => e.preventDefault()}>
        <DialogHeader>
          <DialogTitle>목표 금액 설정</DialogTitle>
        </DialogHeader>
        <DialogDescription className="hidden" />
        <div className="w-full bg-white flex flex-col gap-4">
          <ul className="flex flex-col gap-2 text-sm text-gray-B">
            {newDataList.map(({ label, value }, index) => (
              <li
                key={index}
                className={cn(
                  "h-11 p-2 border-b border-gray-D flex justify-between items-center",
                  { "border-none": index + 1 === newDataList.length }
                )}
              >
                <span className="text-gray-B">{label}년</span>
                <DashboardTargetAmountItem
                  data={value}
                  onChange={(item) =>
                    handleChangeTargetAchievement({ label, value: item })
                  }
                  onCancel={() => {
                    handleChangeTargetAchievement({
                      label,
                      value: oldDataList[index].value,
                    });
                  }}
                />
              </li>
            ))}
          </ul>

          <div className="flex justify-center">
            <CommonButton
              label="설정 완료"
              className="px-5 py-2 bg-dark-red text-sm font-semibold"
              onClick={handleSaveTargetAchievement}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
